import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landingspagina from './pages/Landingspagina';
import Contact from './pages/Contact';
import { ModalProvider } from './context/ModalContext';
import ContactModal from './components/ContactModal';
import Navbar from './components/Navbar';
import './App.css';

function App() {
    useEffect(() => {
        // Initialize Apollo tracking
        function initApollo() {
            var n = Math.random().toString(36).substring(7),
                o = document.createElement("script");
            o.src = "https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=" + n;
            o.async = true;
            o.defer = true;
            o.onload = function () {
                window.trackingFunctions.onLoad({ appId: "693ee1316d085b000dec7414" });
            };
            document.head.appendChild(o);
        }
        initApollo();
    }, []);

    return (
        <ModalProvider>
            <Router>
                <div className="app">
                    <Navbar />

                    <main className="main-content">
                        <Routes>
                            <Route path="/" element={<Landingspagina />} />
                            <Route path="/contact" element={<Contact />} />
                        </Routes>
                    </main>

                    <ContactModal />

                    <footer className="footer">
                        <div className="footer-content">
                            <p>&copy; {new Date().getFullYear()} Veloce Software. Alle rechten voorbehouden.</p>
                            <div className="footer-links">
                                <a href="mailto:info@velocesoftware.nl">info@velocesoftware.nl</a>
                            </div>
                        </div>
                    </footer>
                </div>
            </Router>
        </ModalProvider>
    );
}

export default App;
